import { ClientError } from 'graphql-request';

/**
 * The gateway raises this when a context-scoped operation runs with no active
 * context in the session — expected for a freshly-logged-in or just-invited user
 * who hasn't called `switchContext` yet (T17 handover #4). It is NOT an error to
 * surface: route the user to the context picker instead.
 *
 * Match both the symbolic code and its numeric form, defensively.
 */
export const CONTEXT_REQUIRED_CODES = ['ACL_CONTEXT_REQUIRED', 'ACL_10007'] as const;

/** True when a GraphQL error means "no active context yet" (→ show the picker). */
export function isContextRequiredError(error: unknown): boolean {
  if (!(error instanceof ClientError)) return false;
  const errors = error.response?.errors ?? [];
  return errors.some((e) => {
    const code = e.extensions?.code;
    return (
      (typeof code === 'string' && (CONTEXT_REQUIRED_CODES as readonly string[]).includes(code)) ||
      /\bACL_CONTEXT_REQUIRED\b|\bACL_10007\b/.test(e.message ?? '')
    );
  });
}
